var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindVet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_21_1",
    "data-name": "Component 21 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.029,
    height: 50.776,
    viewBox: "0 0 71.029 50.776",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1705",
    "data-name": "Group 1705",
    transform: "translate(41.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1698",
    "data-name": "Group 1698",
    transform: "translate(2.729 0.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4070",
    "data-name": "Path 4070",
    d: "M601.3,328.031a1.048,1.048,0,0,1-.5-.083h0l-3.307-1.571,3.39-1.488a1.817,1.817,0,0,1,1.158.083l.248.083a1.364,1.364,0,0,1,.744,1.24,1.49,1.49,0,0,1-.744,1.323l-.248.165A1.333,1.333,0,0,1,601.3,328.031Zm-.331-.744a.624.624,0,0,0,.661-.083l.248-.165a.876.876,0,0,0,0-1.488l-.165-.083a.879.879,0,0,0-.661-.083l-1.984.827Z",
    transform: "translate(-597.5 -324.834)",
    fill: "#3a3a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1699",
    "data-name": "Group 1699",
    transform: "translate(0 1.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4071",
    "data-name": "Path 4071",
    d: "M603.709,344.473c-3.142,0-5.705-2.233-7.524-6.367a25.621,25.621,0,0,1-1.984-8.434,3.494,3.494,0,0,1,3.473-3.473v.661a2.788,2.788,0,0,0-2.811,2.811,24.319,24.319,0,0,0,1.9,8.186c1.158,2.729,3.307,5.953,6.946,5.953Z",
    transform: "translate(-594.2 -326.2)",
    fill: "#3a3a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1700",
    "data-name": "Group 1700",
    transform: "translate(10.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4072",
    "data-name": "Path 4072",
    d: "M608.936,328.023a1.334,1.334,0,0,1-.744-.248l-.248-.165a1.4,1.4,0,0,1-.744-1.323,1.426,1.426,0,0,1,.744-1.24l.165-.083a1.4,1.4,0,0,1,1.158-.083h0l3.39,1.406-3.307,1.654C609.35,328.023,609.184,328.023,608.936,328.023Zm0-2.563a.745.745,0,0,0-.413.083l-.248.083a.876.876,0,0,0,0,1.488l.248.165a.663.663,0,0,0,.661.083l1.984-.992-1.984-.827A.3.3,0,0,0,608.936,325.46Z",
    transform: "translate(-607.2 -324.791)",
    fill: "#3a3a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1701",
    "data-name": "Group 1701",
    transform: "translate(9.178 17.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4073",
    "data-name": "Path 4073",
    d: "M610.261,365.744a4.976,4.976,0,0,1-4.961-4.961V345.9h.661v14.883a4.3,4.3,0,1,0,8.6,0V354a4.217,4.217,0,0,1,8.434,0v1.654h-.661V354a3.556,3.556,0,0,0-7.111,0v6.78A5.086,5.086,0,0,1,610.261,365.744Z",
    transform: "translate(-605.3 -345.9)",
    fill: "#3a3a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1702",
    "data-name": "Group 1702",
    transform: "translate(9.509 1.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4074",
    "data-name": "Path 4074",
    d: "M605.7,344.473v-.661c3.556,0,5.705-3.225,6.946-5.953a24.318,24.318,0,0,0,1.9-8.186,2.788,2.788,0,0,0-2.811-2.811V326.2a3.494,3.494,0,0,1,3.473,3.473,23.641,23.641,0,0,1-1.984,8.434C611.405,342.324,608.842,344.473,605.7,344.473Z",
    transform: "translate(-605.7 -326.2)",
    fill: "#3a3a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1703",
    "data-name": "Group 1703",
    transform: "translate(22.904 23.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4075",
    "data-name": "Path 4075",
    d: "M628.849,357.025a3.225,3.225,0,1,1-3.225-3.225A3.284,3.284,0,0,1,628.849,357.025Z",
    transform: "translate(-621.987 -353.552)",
    fill: "#3a3a99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4076",
    "data-name": "Path 4076",
    d: "M625.455,360.611a3.555,3.555,0,1,1,3.556-3.555A3.529,3.529,0,0,1,625.455,360.611Zm0-6.532a2.894,2.894,0,1,0,2.894,2.894A2.825,2.825,0,0,0,625.455,354.079Z",
    transform: "translate(-621.9 -353.5)",
    fill: "#3a3a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1704",
    "data-name": "Group 1704",
    transform: "translate(25.136 25.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4077",
    "data-name": "Path 4077",
    d: "M626.984,357.492a.992.992,0,1,1-.992-.992A1,1,0,0,1,626.984,357.492Z",
    transform: "translate(-624.669 -356.169)",
    fill: "#3a3a99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4078",
    "data-name": "Path 4078",
    d: "M625.923,358.746a1.323,1.323,0,1,1,1.323-1.323A1.306,1.306,0,0,1,625.923,358.746Zm0-1.984a.661.661,0,1,0,.661.661A.652.652,0,0,0,625.923,356.762Z",
    transform: "translate(-624.6 -356.1)",
    fill: "#3a3a99"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1716",
    "data-name": "Group 1716",
    transform: "translate(0 7.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1706",
    "data-name": "Group 1706",
    transform: "translate(17.447 0.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4079",
    "data-name": "Path 4079",
    d: "M574.8,346.355h-5.788a3.317,3.317,0,0,1-3.307-3.307v-5.54a3.317,3.317,0,0,1,3.307-3.307h5.54v1.654h-5.54a1.659,1.659,0,0,0-1.654,1.654v5.54a1.659,1.659,0,0,0,1.654,1.654H574.8Z",
    transform: "translate(-565.7 -334.2)",
    fill: "#30221b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1707",
    "data-name": "Group 1707",
    transform: "translate(26.294 0.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4080",
    "data-name": "Path 4080",
    d: "M581.94,346.355h-5.292V344.7h5.292a1.659,1.659,0,0,0,1.654-1.654v-5.54a1.659,1.659,0,0,0-1.654-1.654H576.4V334.2h5.54a3.317,3.317,0,0,1,3.307,3.307v5.54A3.265,3.265,0,0,1,581.94,346.355Z",
    transform: "translate(-576.4 -334.2)",
    fill: "#30221b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1708",
    "data-name": "Group 1708",
    transform: "translate(20.837 0.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4081",
    "data-name": "Path 4081",
    d: "M575.257,336.642h-4.63a.829.829,0,0,1-.827-.827v-1.488a.829.829,0,0,1,.827-.827h4.63Z",
    transform: "translate(-569.8 -333.5)",
    fill: "#3a3a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1709",
    "data-name": "Group 1709",
    transform: "translate(24.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4082",
    "data-name": "Path 4082",
    d: "M582.569,336.625H576.5V333.4h6.069a.979.979,0,0,1,1.084.827v1.488A.98.98,0,0,1,582.569,336.625Z",
    transform: "translate(-576.5 -333.4)",
    fill: "#3a3a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1710",
    "data-name": "Group 1710",
    transform: "translate(0 7.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4083",
    "data-name": "Path 4083",
    d: "M570.894,378.582H549.4a4.8,4.8,0,0,1-4.8-4.8V347a4.8,4.8,0,0,1,4.8-4.8h21.5Z",
    transform: "translate(-544.6 -342.2)",
    fill: "#f1f1f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1711",
    "data-name": "Group 1711",
    transform: "translate(23.565 7.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4084",
    "data-name": "Path 4084",
    d: "M576.4,342.1h23.729a5.067,5.067,0,0,1,5.293,4.8V373.6a5.067,5.067,0,0,1-5.293,4.8H576.4Z",
    transform: "translate(-576.4 -342.1)",
    fill: "#f1f1f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1712",
    "data-name": "Group 1712",
    transform: "translate(23.069 16.702)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 3.225,
    height: 17.116,
    fill: "#3a3a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1713",
    "data-name": "Group 1713",
    transform: "translate(24.682 16.702)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 4.837,
    height: 17.116,
    fill: "#3a3a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1714",
    "data-name": "Group 1714",
    transform: "translate(17.777 21.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4085",
    "data-name": "Path 4085",
    d: "M566.1,360v6.449h8.516V360Z",
    transform: "translate(-566.1 -360)",
    fill: "#3a3a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1715",
    "data-name": "Group 1715",
    transform: "translate(26.294 21.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4086",
    "data-name": "Path 4086",
    d: "M576.4,360v6.449H585V360Z",
    transform: "translate(-576.4 -360)",
    fill: "#3a3a99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindVet);
export default __webpack_public_path__ + "static/media/FindVet.04ce9d8352e57d05e1f8f473adf9e139.svg";
export { ForwardRef as ReactComponent };